module.exports = __webpack_public_path__ + "static/media/Meng Li.950e15e0.png";